(() => {
  'use strict';
  function initialize() {
    document.querySelectorAll('.sc-stage1-listing').forEach(listing => {
      const toolbar = listing.querySelector('[data-sc-page-size-toolbar]');
      const drawer = listing.querySelector('[data-sc-page-size-drawer]');
      const control = toolbar?.querySelector('.sc-page-size');
      if (!toolbar || !drawer || !control) return;
      const mobile = matchMedia('(max-width: 767px)');
      const move = () => (mobile.matches ? drawer : toolbar).appendChild(control);
      move();
      mobile.addEventListener('change', move);
    });
    const header = document.querySelector('[data-sc-header-search]');
    if (header) {
      const game = header.querySelector('select');
      const query = header.querySelector('input[name="q"]');
      const params = new URLSearchParams(location.search);
      const games = params.getAll('filter.p.m.custom.game').filter(Boolean);
      game.value = games.length === 1 ? games[0] : params.get('game') || '';
      if (!game.value) game.value = '';
      if (params.has('base_q')) query.value = params.get('base_q');
      header.addEventListener('submit', () => {
        query.value = query.value.trim() || '*';
        game.disabled = !game.value;
      });
    }
    document.querySelectorAll('.sc-quick-trigger[popovertarget]').forEach(trigger => {
      const panel = document.getElementById(trigger.getAttribute('popovertarget'));
      if (!panel) return;
      panel.addEventListener('beforetoggle', event => {
        if (event.newState !== 'open') return;
        const rect = trigger.getBoundingClientRect();
        const width = Math.min(320, innerWidth - 24);
        const top = Math.min(rect.bottom + 8, innerHeight - 190);
        panel.style.width = width + 'px';
        panel.style.left = Math.max(12, Math.min(rect.left, innerWidth - width - 12)) + 'px';
        panel.style.top = Math.max(12, top) + 'px';
        panel.style.maxHeight = Math.max(160, innerHeight - top - 24) + 'px';
      });
      panel.addEventListener('toggle', event => {
        trigger.setAttribute('aria-expanded', event.newState === 'open' ? 'true' : 'false');
        if (event.newState === 'open') panel.querySelector('a, input, button')?.focus();
      });
      panel.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        panel.hidePopover();
        trigger.focus();
      });
    });
    document.querySelectorAll('[data-sc-quick-price]').forEach(box => {
      const minimum = box.querySelector('[data-price-min]');
      const maximum = box.querySelector('[data-price-max]');
      const clearError = () => maximum.setCustomValidity('');
      minimum.addEventListener('input', clearError);
      maximum.addEventListener('input', clearError);
      const apply = () => {
        clearError();
        if (minimum.value && maximum.value && Number(maximum.value) < Number(minimum.value)) maximum.setCustomValidity(box.dataset.invalidRange);
        if (!minimum.reportValidity() || !maximum.reportValidity()) return;
        const url = new URL(location.href);
        url.searchParams.delete('page');
        for (const [name, field] of [['filter.v.price.gte', minimum], ['filter.v.price.lte', maximum]]) {
          if (field.value !== '') url.searchParams.set(name, field.value);
          else url.searchParams.delete(name);
        }
        location.assign(url.href);
      };
      box.querySelector('[data-price-apply]').addEventListener('click', apply);
      box.addEventListener('keydown', event => {
        if (event.key === 'Enter') { event.preventDefault(); apply(); }
      });
    });
    const scope = document.querySelector('[data-sc-quick-filters][data-kind="search"]');
    if (scope) {
      const initial = new URL(location.href);
      const types = initial.searchParams.getAll('filter.p.product_type').flatMap(value => value.split(','));
      const searchInput = document.getElementById('TcgSearchInput');
      scope.querySelectorAll('[data-sc-quick-type]').forEach(link => {
        const selected = types.length === 1 && types[0] === link.dataset.scQuickType;
        if (selected) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
        const check = link.querySelector('.sc-quick-check');
        check.textContent = selected ? '✓' : '';
        const target = new URL(initial);
        target.searchParams.delete('page');
        target.searchParams.delete('format');
        target.searchParams.delete('filter.p.product_type');
        target.searchParams.set('filter.p.product_type', link.dataset.scQuickType);
        const term = searchInput?.value.trim() || initial.searchParams.get('base_q') || '';
        if (!term || !/product_type:|tag:/.test(term)) target.searchParams.set('q', term || '*');
        link.href = target.pathname + target.search;
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();
